import type { ReactNode } from 'react'
import type { Table } from '@tanstack/react-table'
import { DataTableContext } from './DataTableContext'

type DataTableRootProps<TData> = {
  table: Table<TData>
  children: ReactNode
}

export function DataTableRoot<TData>({ table, children }: DataTableRootProps<TData>) {
  return <DataTableContext.Provider value={table}>{children}</DataTableContext.Provider>
}
